module.exports = __webpack_public_path__ + "static/media/home_add_event_bg.7678cc5e.jpg";